module.exports = __webpack_public_path__ + "img/tmdb.56fd61ee.svg";